<template>
  <transition name="screenslideup">
    <div v-show="true" class="modal-overlay">
      <div class="modal" style="height: 88vh; overflow-y: auto;">
        <table border="0" width="90%">
          <!-- Cancel & Logo -->
          <tr>
            <td>
              <div class="divl" style="height: 6vh">
                <button class="text-only-button cancel" @click="doCancel">Cancel</button>
              </div>
              <div class="wrapper-todiv" style="height: 8vh">
                <img class="tulogo" style="height: 7vh;" alt="ThankU logo" src="../assets/tutxtlogo.png">
              </div>
            </td>
          </tr>

          <!-- Header -->
          <tr>
            <td>
              <div class="lt-blue txtc" :style="{ 'font-size': fontSizeTitle + 'vh', 'line-height': fontSizeTitleLineHeight + 'vh' }">
                Document Upload
              </div>
            </td>
          </tr>

          <!-- Proof of ID Section -->
          <tr>
            <td>
              <div class="lt-blue txtc" style="font-size: 2.2vh; padding-top: 2vh;">
                <b>1. Proof of Identity</b>
              </div>
              <div class="lt-blue notes-text" style="padding: 0.5vh 0;">
                Please upload a clear photo of your passport or driving licence
              </div>
              <div style="padding-bottom: 1vh;">
                <label class="lt-blue notes-text">Select ID Type:</label><br/>
                <select v-model="selectedIdType" style="width: 100%; padding: 0.5vh;">
                  <option disabled value="">Please choose</option>
                  <option value="Passport">Passport</option>
                  <option value="DriversLicense">Driving Licence</option>
                </select>
              </div>
            </td>
          </tr>

          <!-- Front of ID -->
          <tr v-if="selectedIdType">
            <td>
              <div class="lt-blue notes-text"><b>Front of {{ selectedIdType }}</b></div>
              <div style="display: flex; align-items: center; gap: 1vh; padding-bottom: 1vh;">
                <input ref="idFrontFileInput" type="file" accept="image/*,.pdf" @change="handleIdFrontUpload" capture style="display: none;" />
                <button class="widebtn" @click="$refs.idFrontFileInput.click()" style="width: 50%">Choose/Take Photo</button>
                <span v-if="idFrontFileName" class="lt-blue" style="font-size: 1.8vh;">✓ {{ idFrontFileName }}</span>
              </div>
            </td>
          </tr>

          <!-- Back of ID (only if Driving Licence) -->
          <tr v-if="selectedIdType === 'DriversLicense'">
            <td>
              <div class="lt-blue notes-text"><b>Back of Driving Licence</b></div>
              <div style="display: flex; align-items: center; gap: 1vh; padding-bottom: 1vh;">
                <input ref="idBackFileInput" type="file" accept="image/*,.pdf" @change="handleIdBackUpload" capture style="display: none;" />
                <button class="widebtn" @click="$refs.idBackFileInput.click()" style="width: 50%">Choose/Take Photo</button>
                <span v-if="idBackFileName" class="lt-blue" style="font-size: 1.8vh;">✓ {{ idBackFileName }}</span>
              </div>
            </td>
          </tr>

          <!-- Proof of Address Section -->
          <tr>
            <td>
              <div class="lt-blue txtc" style="font-size: 2.2vh; padding-top: 2vh;">
                <b>2. Proof of Address</b>
              </div>
              <div class="lt-blue notes-text" style="padding: 0.5vh 0;">
                Upload a recent utility bill (less than 3 months old)
              </div>
              <div style="display: flex; align-items: center; gap: 1vh;">
                <input ref="addressFileInput" type="file" accept="image/*,.pdf" @change="handleAddressUpload" capture style="display: none;" />
                <button class="widebtn" @click="$refs.addressFileInput.click()" style="width: 50%">Choose/Take Photo</button>
                <span v-if="addressFileName" class="lt-blue" style="font-size: 1.8vh;">✓ {{ addressFileName }}</span>
              </div>
            </td>
          </tr>

          <!-- Uploading -->
          <tr v-if="isUploading">
            <td>
              <div class="lt-blue txtc" style="padding-top: 2vh; font-size: 2vh;">
                Uploading documents... {{ uploadProgress }}%
              </div>
            </td>
          </tr>

          <!-- Submit -->
          <tr>
            <td style="height: 10vh;">
              <div>
                <button class="widebtn" style="width: 70%; height: 5vh;" @click="doUploadDocuments" :disabled="!canSubmit || isUploading">
                  {{ isUploading ? 'Uploading...' : 'Submit Documents' }}
                </button>
              </div>
            </td>
          </tr>

          <!-- Footer Note -->
          <tr>
            <td>
              <div class="lt-blue notes-text" style="padding-top: 1vh;">
                Your documents are securely encrypted and stored. They will only be used for identity verification purposes.
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </transition>
</template>

<script>
import shared from '../shared.js';
export default {
  name: 'DocumentUploadScreen',
  props: {
    userData: shared.userDataStruct(),
  },
  data() {
    return {
      fontSizeTitle: 2.7,
      fontSizeTitleLineHeight: 5,
      selectedIdType: '',
      idFrontFile: null,
      idFrontFileName: '',
      idBackFile: null,
      idBackFileName: '',
      addressFile: null,
      addressFileName: '',
      isUploading: false,
      uploadProgress: 0
    };
  },
  computed: {
    canSubmit() {
      const idOk = this.selectedIdType === 'Passport'
        ? this.idFrontFile
        : this.idFrontFile && this.idBackFile;
      return idOk && this.addressFile && !this.isUploading;
    }
  },
  methods: {
    doCancel() {
      this.$emit('next-action', {
        nextScreen: 'showPersonalDetails',
        userData: this.userData
      });
    },
    handleIdFrontUpload(event) {
      const file = event.target.files[0];
      if (this.validateFile(file)) {
        this.idFrontFile = file;
        this.idFrontFileName = file.name;
      }
    },
    handleIdBackUpload(event) {
      const file = event.target.files[0];
      if (this.validateFile(file)) {
        this.idBackFile = file;
        this.idBackFileName = file.name;
      }
    },
    handleAddressUpload(event) {
      const file = event.target.files[0];
      if (this.validateFile(file)) {
        this.addressFile = file;
        this.addressFileName = file.name;
      }
    },
    validateFile(file) {
      const maxSizeInBytes = 10 * 1024 * 1024;
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
      if (file.size > maxSizeInBytes) {
        this.$emit('show-popup', {
          title: 'File Too Large',
          body: 'Please select a file smaller than 10MB'
        });
        return false;
      }
      if (!allowedTypes.includes(file.type)) {
        this.$emit('show-popup', {
          title: 'Invalid File Type',
          body: 'Please upload a JPEG, PNG, or PDF file'
        });
        return false;
      }
      return true;
    },
    async convertFileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    async doUploadDocuments() {
      if (!this.canSubmit) return;
      try {
        this.isUploading = true;
        this.uploadProgress = 20;

        const Parse = require('parse/node');
        const proofOfIdData = await this.convertFileToBase64(this.idFrontFile);
        const proofOfAddressData = await this.convertFileToBase64(this.addressFile);
        const proofOfIdBackData = this.idBackFile ? await this.convertFileToBase64(this.idBackFile) : null;

        this.uploadProgress = 60;

        const params = {
          userObjectId: window.localStorage.getItem("tuob"),
          idType: this.selectedIdType,
          proofOfIdData,
          proofOfIdFileName: this.idFrontFile.name,
          proofOfIdFileType: this.idFrontFile.type,
          proofOfIdBackData,
          proofOfIdBackFileName: this.idBackFile ? this.idBackFile.name : "",
          proofOfIdBackFileType: this.idBackFile ? this.idBackFile.type : "",
          proofOfAddressData,
          proofOfAddressFileName: this.addressFile.name,
          proofOfAddressFileType: this.addressFile.type
        };

        await Parse.Cloud.run("uploadVerificationDocuments", params);
        this.uploadProgress = 100;

        this.userData.documentsUploaded = true;
        setTimeout(() => {
          this.isUploading = false;
          this.$emit('show-popup', {
            title: 'Documents Uploaded',
            body: 'Your documents have been successfully uploaded for verification.',
            callback: () => {
              this.$emit('next-action', {
                nextScreen: 'showAccountScreen',
                userData: this.userData
              });
            }
          });
        }, 500);
      } catch (e) {
        this.isUploading = false;
        this.uploadProgress = 0;
        this.$emit('show-popup', {
          title: 'Upload Failed',
          body: 'Failed to upload documents: ' + (e.message || e)
        });
      }
    }
  }
};
</script>
